import React from 'react'
export default function TickIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25">
            <path fillRule="evenodd" d="M12.1 22.32a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 2a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z" clipRule="evenodd"/>
            <path fillRule="evenodd" d="M18.87 8.78 9.1 18.55l-4.6-4.59 1.42-1.41 3.18 3.18 8.36-8.37 1.41 1.42Z" clipRule="evenodd"/>
        </svg>
    )
}


